import { saveAs } from "file-saver";
import { Message } from "element-ui";

/**
 * @description 通过axios导出文件
 * @param {Promise<Blob>} promise
 * @returns
 */
export const setFileApi = async (promise, message) => {
  Message({
    type: "warning",
    message: message || "正在导出文件,请稍等...",
    duration: 0,
    showClose: true
  });
  const errObj = { message: "导出失败" };
  try {
    const res = await promise;
    Message.closeAll();
    return res;
  } catch (error) {
    Message.closeAll();
    const text =
      await error.response?.data?.text?.();
    let message = errObj;
    if (text) {
      try {
        message = JSON.parse(text);
      } catch (error) {
        message = errObj;
      }
    }
    Message.error(message);
  }
};

/**
 *
 * @param {Promise<Blob>} promise 已调用接口返回的promise
 * @param {string|Function} fileName  文件名称
 * @param {string} message  导出提示
 */
export const exportFile = async (promise, fileName, message) => {
  const blob = await setFileApi(promise, message);
  const name = fileName instanceof Function ? fileName(blob) : fileName || `${blob}`;
  saveAs(blob, name);
};
